import "./login.scss";
import { Form, Field, ErrorMessage, Formik } from "formik";
import axios from "axios";
import useAuth from "../../authentication/useAuth";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

export default function Login({ updater }) {
  const navigate = useNavigate();
  const { UserInfo, logout, login, isLogged } = useAuth();
  const sendUserPass = (userName, password) => {
    let fd = new FormData();
    fd.append("username", userName);
    fd.append("password", password);
    let a = axios.post("http://www.smarteca.ir/amlak/?action=login", fd);

    a.then(({ data }) => {
      if (data.state == 1) {
        login(userName, password, data.token);
        updater();
        navigate("/");
      } else {
        // to do :red alert
        toast.error("نام کاربری یا رمز عبور شما، اشتباه است.");
      }
    });
  };
  return (
    <>
      <div className="login-container">
        <div className="login-section row">
          <div className="col-12 col-md-6 right-side d-flex flex-column align-items-center justify-content-around">
            <div className="title">
              وزارت صنعت معدن و تجارت
              <br />
              <div className="mt-2" style={{ fontSize: "18px" }}>
                اتحادیه مشاورین املاک گرگان
              </div>
            </div>

            <Formik
              onSubmit={({ userName, password }) => {
                sendUserPass(userName, password);
              }}
              initialValues={{ userName: "", password: "" }}
              validate={(values) => {
                const errors = {};
                if (values.userName == "") {
                  errors.userName = "این فیلد نمیتواند خالی باشد";
                } else if (values.password == "") {
                  errors.password = "این فیلد نمیتواند خالی باشد";
                }
                return errors;
              }}
              validateOnBlur={false}
              validateOnChange={false}
            >
              <Form>
                <label htmlFor="userName">نام کاربری</label>
                <Field name="userName" id="userName" className="text-start form-control my-1"></Field>
                <ErrorMessage name="userName" component="div" style={{ color: "red", fontSize: "13px", marginTop: "8px" }}></ErrorMessage>
                <label htmlFor="password">رمز عبور</label>
                <Field name="password" id="password" type="password" className="form-control my-1"></Field>
                <ErrorMessage name="password" component="div" style={{ color: "red", fontSize: "13px", marginTop: "8px" }}></ErrorMessage>

                <div className="text-start mt-3" style={{ fontSize: "15px", color: "gray" }}>
                  در صورت فراموشی رمز عبور، با ما تماس بگیرید
                </div>

                <div className="submit-button mt-3">
                  <button className="btn btn-primary">ورود</button>
                </div>
              </Form>
            </Formik>
          </div>
          <div className="d-none d-md-block col-md-6 left-side"></div>
        </div>
      </div>
    </>
  );
}
